export const KineticLensAbi = [
  {
    inputs: [],
    name: 'getMarketMetadataForAllMarkets',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'market', type: 'address' },
          { internalType: 'uint256', name: 'supplyRate', type: 'uint256' },
          { internalType: 'uint256', name: 'borrowRate', type: 'uint256' },
          { internalType: 'uint256', name: 'price', type: 'uint256' },
          { internalType: 'uint256', name: 'exchangeRate', type: 'uint256' },
          { internalType: 'uint256', name: 'reserveFactor', type: 'uint256' },
          { internalType: 'uint256', name: 'borrowCap', type: 'uint256' },
          { internalType: 'uint256', name: 'totalSupply', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'totalUnderlyingSupply',
            type: 'uint256',
          },
          { internalType: 'uint256', name: 'totalBorrows', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'collateralFactor',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'underlyingToken',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'underlyingTokenDecimals',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'cTokenDecimals',
            type: 'uint256',
          },
          {
            internalType: 'uint256[]',
            name: 'supplyRewardSpeeds',
            type: 'uint256[]',
          },
          {
            internalType: 'uint256[]',
            name: 'borrowRewardSpeeds',
            type: 'uint256[]',
          },
          { internalType: 'uint256', name: 'totalReserves', type: 'uint256' },
          { internalType: 'uint256', name: 'cash', type: 'uint256' },
          { internalType: 'bool', name: 'mintPaused', type: 'bool' },
          { internalType: 'bool', name: 'borrowPaused', type: 'bool' },
          {
            internalType: 'uint256',
            name: 'accrualBlockTimestamp',
            type: 'uint256',
          },
        ],
        internalType: 'struct Lens.MarketMetadata[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const
